import React from "react";
import Badge from "react-bootstrap/Badge";
import {
  PiCheckFatFill,
  PiClockFill,
  PiHammerFill,
  PiTrashFill,
} from "react-icons/pi";
import "./ProductStatutBadge.css";

const libelleStatutBadge = ({ idStatut, libelleStatut, type, size }) => {
  const objectSize = {
    xs: {
      iconSize: 15,
      textSize: "",
    },
    sm: {
      iconSize: 20,
      textSize: "h4",
    },
    md: {
      iconSize: 30,
      textSize: "h3",
    },
    lg: {
      iconSize: 40,
      textSize: "h4",
    },
    xl: {
      iconSize: 38,
      textSize: "h2",
    },
  };

  size = size ? size : "xs";

  const getBadgeContent = () => {
    switch (idStatut) {
      case "1":
        return (
          <Badge
            bg="light-primary d-flex align-items-enter justify-content-center"
            className="w-100"
            text="primary"
          >
            <PiHammerFill className="me-2" size={objectSize[size].iconSize} />{" "}
            <span
              className={
                "d-none d-lg-inline-block mt-1 mb-1 " +
                objectSize[size].textSize
              }
            >
              {libelleStatut}
            </span>
          </Badge>
        );
      case "2":
      case "3":
      case "4":
        return (
          <Badge
            bg="light-warning d-flex align-items-enter justify-content-center"
            className="w-100"
            text="warning"
          >
            <PiClockFill className="me-2" size={objectSize[size].iconSize} />{" "}
            <span
              className={
                "d-none d-lg-inline-block mt-1 mb-1 " +
                objectSize[size].textSize
              }
            >
              {libelleStatut}
            </span>
          </Badge>
        );
      case "5":
        return (
          <Badge
            bg="light-secondary d-flex align-items-enter justify-content-center"
            className="w-100"
            text="secondary"
          >
            <PiTrashFill className="me-2" size={objectSize[size].iconSize} />{" "}
            <span
              className={
                "d-none d-lg-inline-block mt-1 mb-1 " +
                objectSize[size].textSize
              }
            >
              {libelleStatut}
            </span>
          </Badge>
        );
      case "6":
        return (
          <Badge
            bg="light-success d-flex align-items-enter justify-content-center"
            className="w-100"
            text="success"
          >
            <PiCheckFatFill className="me-2" size={objectSize[size].iconSize} />{" "}
            <span
              className={
                "d-none d-lg-inline-block mt-1 mb-1 " +
                objectSize[size].textSize
              }
            >
              {libelleStatut}
            </span>
          </Badge>
        );
      default:
        return <>{libelleStatut}</>;
    }
  };

  const getOutput = () => {
    switch (type) {
      case "badge":
        return getBadgeContent();
      case "bg":
        return (
          "text-" +
          getBadgeContent().props.text +
          " bg-" +
          getBadgeContent().props.bg
        );
      case "icon":
        return getBadgeContent().props.children[0];
      default:
        return getBadgeContent();
    }
  };

  return getOutput();
};

export default libelleStatutBadge;
